<template>
  <div class="login">
    <table class="squared">
      <thead class="login-part">
        <div class="imgBox">
          <a href="javascript:void(0);" class="userImg">
            <img src="http://images.xdf.cn/cms20150819/zuixinban/images/unloadicon_gw.png" alt="">
          </a>
        </div>
        <!-- 登录前 -->
        <div class="userInfo" v-if="getLoginName">
          <div class="afterLogin">
            <p class="nickName">Hi，<span style="color: #00b388;" ref="loginName" :title="getLoginName"></span></p>
            <p>欢迎来到新东方<a :href="getLogoutUrl">退出</a></p>
          </div>
        </div>
        <!-- 登录后 -->
        <div class="userInfo" v-else>
          <div class="beforeLogin">Hi，欢迎来到新东方</div>
          <div class="btns">
            <a :href='getLoginUrl'>请登录</a>
            <!-- <a :href='getRegisterUrl'>注册</a> -->
          </div>
        </div>
      </thead>
      <tbody class="squared-part">
        <tr class="top-group">
          <div class="enroll" href="javascript:void(0);">
            <i class="icon" style="background-position: -84px 2px"></i>
            <div class="inp">
              <textarea id="fast-search" @keyup.13="submit" @focus="cleararea" @blur="defaultarea" ref="fastsearch" placeholder="请输入班号，最多支持10个班号联报，班号间用“,”隔开。" cols="4" rows="4" v-model="classCode"></textarea>
              <a
                :href="cityId?`http://souke1.xdf.cn/AddShopCart.aspx?SchoolId=${cityFormInfo[cityId].schoolId}&ClassCode=${classCode}&type=coursedetail`:''"
              >立即<br />报班</a>
            </div>
            快捷报班
          </div>
          <a
            :href="`http://souke.xdf.cn/Teacher/${soukecityId}.html`"
            target="_blank"
          >
            <i class="icon" style="background-position: 0 -200px"></i>
            热报课程
          </a>
          <a
            :href="`http://souke.xdf.cn/Campus/${soukecityId}.html`"
            target="_blank"
          >
            <i class="icon" style="background-position: -86px -76px"></i>
            校区查询
          </a>
        </tr>
        <tr class="bottom-group">
          <a
            href="http://www.xdf.cn/zhuanti/kaoshiyueli.html"
            target="_blank"
          >
            <i class="icon" style="background-position: -164px 2px"></i>
            考试月历
          </a>
          <a
            href="http://gaokao.xdf.cn/college/china/searchSchool"
            target="_blank"
          >
            <i class="icon" style="background-position: -164px -76px"></i>
            院校库
          </a>
          <a
            href="http://www.xdf.cn/toutiao/"
            target="_blank"
          >
            <i class="icon" style="background-position: 0 -250px"></i>
            教育头条
          </a>
        </tr>
      </tbody>
    </table>
    <news
      title_1="最新活动"
      title_2="集团新闻"
      adCode="213"
      :newsData="newsData"
      href_1=""
      href_2="http://www.xdf.cn/info/list_1350_1.html"></news>
  </div>
</template>

<script>
import { cityFormInfo } from 'js/staticData.js'
import { u2RootPath, appId } from 'js/home/staticdata.js'
import { getArticle } from 'js/getArticle.js'
import News from '@/common-components/News'
import { mapState } from 'vuex'
import AdModel from '@/common-components/AdModel'
export default {
  name: 'Login',
  components: {
    AdModel,
    News
  },
  data () {
    return {
      currItem: '最新活动',
      newsData: Array,
      cityFormInfo,
      classCode: ''
    }
  },
  created () {
    this.getNewsData()
  },
  mounted () {
    if (this.$cookies.get('U2NickName')) {
      this.$refs['loginName'].innerText = this.$cookies.get('U2NickName')
    }
  },
  computed: {
    // getRegisterUrl () {
    //   return `${u2RootPath}i/u7/Register.aspx?AppId=${appId.toString()}&ReturnUrl=${encodeURIComponent(window.location.href)}`
    // },
    getLoginUrl () {
      // {u2RootPath}Index.aspx?AppId=${appId.toString()}&ReturnUrl=${encodeURIComponent(window.location.href)}
      return `https://login.xdf.cn/sso/login?client_id=9879&response_type=&scope=&state=&ehr_org_id=105&redirect_uri=${encodeURIComponent(window.location.href)}`
    },
    getLogoutUrl () {
      return `${u2RootPath}Logout.aspx?AppId=${appId.toString()}&ReturnUrl=${encodeURIComponent(window.location.href)}`
    },
    getLoginName () {
      if (this.$cookies.get('U2NickName')) {
        return this.$cookies.get('U2NickName')
      } else {
        return false
      }
    },
    cityId () {
      return this.soukecityId
    },
    ...mapState(['soukecityId'])
  },
  watch: {
    cityId (newVal) {
      if (newVal) {
        this.currItem = '最新活动'
      }
    }
  },
  methods: {
    cleararea () {
      if (this.$refs.fastsearch.innerHTML === '请输入班号，最多支持10个班号联报，班号间用“,”隔开。') {
        this.$refs.fastsearch.innerHTML = ''
      }
    },
    defaultarea () {
      if (this.$refs.fastsearch.innerHTML === '') {
        this.$refs.fastsearch.innerHTML = '请输入班号，最多支持10个班号联报，班号间用“,”隔开。'
      }
    },
    submit (e) {
      window.open('http://souke1.xdf.cn/AddShopCart.aspx?SchoolId=1&ClassCode=aaa&type=coursedetail')
    },
    newshandle (e) {
      this.currItem = e.target.innerHTML
    },
    getNewsData () {
      getArticle(1350, 3, '').then(response => {
        this.newsData = response
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.icon
  position: $abs
  width: 50px
  height: 50px
  top: 0
  left: 50%
  margin-left: -25px
  background: url(http://file.xdf.cn/neworiental/images/icons.png?20190410) no-repeat
.activity-content >>> .zey_class_switch_area
  width: 0
  height: 0
.login
  margin-left: 8px
  display: flex
  flex-direction: column
  width:247px
  height:330px
  float:left
  .squared
    flex: 5
    flex-direction: column
    border-collapse: collapse
    .login-part
      flex: 3
      border: 1px solid #dfdfdf
      border-bottom: 0
      display: flex
      height: 100%
      justify-content: center
      align-items: center
      width:245px
      clear :both
      height:51px
      .imgBox
        flex: 1
        text-align: center
        float:left
        margin-top:3px
        .userImg
          width: 45px
          height: 45px
          overflow: hidden
          text-align: center
          border-radius: 50%
          img
            width: 100%
            height: 100%
      .userInfo
        flex: 2
        display: flex
        height: 100%
        line-height: 10px
        float:left
        margin-top:4px
        flex-direction: column
        .beforeLogin
          flex: 3
          display: flex
          align-items: center
        .afterLogin
          flex: 1
          display: flex
          flex-direction: column
          p
            flex: 1
            line-height: 20px
            width: 160px
            ellipsis()
          .nickName
            line-height: 30px
            a
              margin: 0
        .btns
          flex: 2
          display: flex
          margin: 0 10px
          margin-top:11px\9\0
          a
            margin: 0 10px
      a
        color: $themeColor
        margin: 0 10px
        &:hover
          color: #169d84
    .squared-part
      // flex: 8
      // display: flex
      flex-direction: column
      .top-group
        display: flex
        flex: 1
        a
          flex: 1
          padding-top: 45px
          text-align: center
          line-height: 28px
          width:80px
          float:left
          color: #5F5F5F
          border: 1px solid #dfdfdf
          border-left: 0
          border-bottom: 0
          position: $rel
          cursor: pointer
          &:hover
            color: $themeColor
        .enroll
          flex: 1
          padding-top: 45px
          text-align: center
          line-height: 28px
          color: #5F5F5F
          border: 1px solid #dfdfdf
          border-bottom: 0
          position: $rel
          cursor: pointer
          width:80px
          float:left
          .inp
            display: none
            width: 228px
            height: 81px
            position: $abs
            padding: 0 10px
            top: 100%
            left: -1px
            z-index: 1
            justify-content: center
            align-items: center
            background: url(http://images.xdf.cn/cms20150819/zuixinban/images/fast_classbg.png) no-repeat
            #fast-search
              width: 164px
              height: 44px
              padding: 2px
              flex: 7
              color: rgb(96, 96, 96)
              border: 1px solid #ccc
              line-height: 20px
              font-size: 12px
              color: #606060
              outline: none
              resize: none
            a
              padding-top: 0
              flex: 2
              height: 38px
              font-size: 16px
              line-height: 20px
              background: $themeColor
              color: #fff
              border: 0
              padding: 6px 0
          &:hover
            color: $themeColor
            border: 1px solid $themeColor
            .inp
              display: flex
      .bottom-group
        flex: 1
        display: flex
        border-left: 1px solid #dfdfdf
        a
          flex: 1
          padding-top: 45px
          text-align: center
          line-height: 28px
          width:80px
          float:left
          color: #5F5F5F
          border: 1px solid #dfdfdf
          border-left: 0
          position: $rel
          &:hover
            color: $themeColor
  .news
    flex: 3
    margin-top: 12px
    display: flex
    min-height: 117px;
    flex-direction: column
    .title
      // flex: 1
      width:247px
      height :38px
      line-height :38px
      ul
        height: 100%
        background: #f6f6f6
        li
          width: 80px
          height: 100%
          cursor: pointer
          color: #606060
          font-size: 14px
          display: flex
          justify-content: center
          align-items: center
          float: $fl
          box-sizing: border-box
        .active
          background: #fff
          border: 1px solid #e8e8e8
          border-bottom: 0
    .content
      flex: 3
      height: 100%
      border: 1px solid #e8e8e8
      border-top: 0
      padding-left: 10px
      .news-content
        padding-top: 4px
        li
          height: 22px
          width: 203px
          line-height: 22px
          padding-left: 10px
          overflow: hidden
          font-size: 12px
          background: url(http://images.xdf.cn/cms20150819/xinbannew/img/dian.jpg) no-repeat left center
          a
            color: #606060
            height: 100%
            width: 100%
            &:hover
              color: $themeColor
</style>



// WEBPACK FOOTER //
// src/pages/home/components/swiper/components/right-part/components/Login.vue